import React, { Component } from 'react';
import moment from 'moment';
import { Button, Icon } from 'antd';
import { WeekWrapper, ButtonGroup, Divide } from './styles';

const format = 'YYYY-MM-DD';

class WeekPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pickerOpen: false,
      selected: {},
      next: {},
      prev: {},
    };

    this.togglePicker = this.togglePicker.bind(this);
    this.selectWeek = this.selectWeek.bind(this);
  }

  componentDidMount() {
    const { startDate } = this.props;
    // If startDate is defined, use it to set the week otherwise, use moment's default,
    // which is today's current date.
    this.selectWeek(moment(startDate));
  }

  componentDidUpdate(prevProps) {
    const { startDate } = this.props;
    if (prevProps.startDate === startDate) return false;
    this.selectWeek(moment(startDate));
    return true;
  }

  togglePicker() {
    const { pickerOpen } = this.state;
    this.setState({ pickerOpen: !pickerOpen });
  }

  selectWeek(data, callBack) {
    const next = moment(data).add(1, 'weeks');
    const prev = moment(data).subtract(1, 'weeks');

    // Shared function to generate datetime object for state changes.
    const genData = momentObj => ({
      moment: momentObj,
      start: momentObj.startOf('week').format(format),
      end: momentObj.endOf('week').format(format),
    });

    this.setState({
      pickerOpen: false,
      selected: genData(data),
      next: genData(next),
      prev: genData(prev),
    }, () => {
      const { selected } = this.state;
      if (callBack) callBack(selected);
    });
  }

  render() {
    const {
      onChange, disabled, startDate, ...rest
    } = this.props;
    const {
      pickerOpen, selected, next, prev,
    } = this.state;
    const dateFormat = 'DD/MM';
    const displayStart = moment(selected.start).format(dateFormat);
    const displayEnd = moment(selected.end).format(dateFormat);
    return (
      <ButtonGroup
        mr="15px"
        {...rest}
      >
        <Button
          icon="left"
          disabled={disabled}
          onClick={() => this.selectWeek(prev.moment, onChange)}
        />

        <Button
          disabled={disabled}
          onClick={this.togglePicker}
        >
          <Icon type="calendar" />
          {displayStart}
          <Divide m={1} />
          {displayEnd}
        </Button>

        <WeekWrapper
          value={selected.moment}
          onChange={data => this.selectWeek(data, onChange)}
          onOpenChange={status => !status && this.togglePicker()}
          open={pickerOpen}
        />

        <Button
          icon="right"
          disabled={disabled}
          onClick={() => this.selectWeek(next.moment, onChange)}
        />
      </ButtonGroup>
    );
  }
}

export default WeekPicker;
